import { createSiteToastApi } from '../helpers.js';
const showAlertMsg = createSiteToastApi({ durationMs: 6000, resizeNamespace: 'managerToastPlacement' });

export { showAlertMsg };
